import { render, staticRenderFns } from "./GameSession.vue?vue&type=template&id=7f48b62c&scoped=true&"
import script from "./GameSession.vue?vue&type=script&lang=js&"
export * from "./GameSession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f48b62c",
  null
  
)

export default component.exports